import React from 'react';
import css from './loader.module.scss';

interface LoaderProps {
	isVisible: boolean;
}

const Loader: React.FC<LoaderProps> = ({ isVisible }): JSX.Element | null => {
	if (!isVisible) return null;

	return (
		<div className="bg-white p-2 border d-flex my-3">
			<div className={css.loader + ' w-100'}>
				<i className="fa fa-spinner fa-spin"></i>
			</div>
		</div>
	);
};

export default Loader;
